const DAY_KEY_FORMATTERS = new Map<string, Intl.DateTimeFormat | null>();

/** `YYYY-MM-DD` of an instant in an IANA zone, or null when the zone is unknown. */
export function getCalendarDayKey(
  instantMs: number,
  timeZone: string,
): string | null {
  const formatter = getDayKeyFormatter(timeZone);
  if (!formatter || !Number.isFinite(instantMs)) {
    return null;
  }
  const parts = formatter.formatToParts(new Date(instantMs));
  const valueOf = (type: string) =>
    parts.find((part) => part.type === type)?.value;
  return `${valueOf('year')}-${valueOf('month')}-${valueOf('day')}`;
}

function getDayKeyFormatter(timeZone: string): Intl.DateTimeFormat | null {
  const cached = DAY_KEY_FORMATTERS.get(timeZone);
  if (cached !== undefined) {
    return cached;
  }
  const formatter = createDayKeyFormatter(timeZone);
  DAY_KEY_FORMATTERS.set(timeZone, formatter);
  return formatter;
}

function createDayKeyFormatter(timeZone: string): Intl.DateTimeFormat | null {
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  } catch {
    return null;
  }
}
